import { addSentryBreadcrumb } from '@atlassian/conversation-assistant-instrumentation/services/sentry';
import type { AssistanceService } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	ROVO_AGENT_NAMED_ID,
	ROVO_AGENT_UUID,
} from '@atlassian/conversation-assistant-utils/default-agent';

const normalizeAgentId = (id: string): string =>
	id === ROVO_AGENT_NAMED_ID ? ROVO_AGENT_UUID : id;

export const resolveCreateAgentIdentityAccountId = async ({
	assistanceService,
	catalogAgentId,
	existingIdentityAccountId,
}: {
	assistanceService: Pick<AssistanceService, 'getAgentDetails'>;
	catalogAgentId: string | undefined;
	existingIdentityAccountId?: string | null;
}): Promise<string | undefined> => {
	if (existingIdentityAccountId) {
		return existingIdentityAccountId;
	}
	if (!catalogAgentId) {
		return undefined;
	}

	try {
		const normalizedCatalogAgentId = normalizeAgentId(catalogAgentId);
		const agent = await assistanceService.getAgentDetails(normalizedCatalogAgentId);
		return normalizeAgentId(agent.id) === normalizedCatalogAgentId
			? (agent.identity_account_id ?? undefined)
			: undefined;
	} catch {
		// Identity lookup must not prevent the user from generating their page.
		addSentryBreadcrumb({ message: 'Unable to resolve Create with Rovo agent identity' });
		return undefined;
	}
};
